export default __webpack_public_path__ + "static/media/Erika_Brechtel_AHV_In_Moms_We_Trust.28ae5912.jpg";